<span class="mx-2 flex h-10 w-10 items-center justify-center rounded-full" [style.backgroundColor]="award.awardType | awardColour">
  <rma-icon glyph="rma-award" />
</span>

<div class="mx-4">
  <p class="w-18 pr-2 font-bold">{{ award | awardRank }}</p>
  <p class="max-w-full whitespace-nowrap text-steel-70">{{ award.awardName }}</p>
</div>
